// extracted by mini-css-extract-plugin
export default {"overlayClass":"loadingIndicator_overlayClass__tYJj4","spinnerClass":"loadingIndicator_spinnerClass__R5cx1"};